import { preparePayloadForGraphQL } from '@/helpers/validate';

/**
 * Fields of `investmentDeductionAllowance` saved by the block project-financing ("Finanzierung")
 * with their payload type (`preparePayloadForGraphQL`). Must match `ProjectFinancingInput`.
 */
const PROJECT_FINANCING_FIELD_TYPES = {
  durationYears: 'number',
  interestRatePercent: 'number',
  fixedRateYears: 'number',
  repaymentRatePercent: 'number',
};

export const PROJECT_FINANCING_INPUT_FIELDS = Object.keys(PROJECT_FINANCING_FIELD_TYPES);

/**
 * `ProjectFinancingInput` from the block object (or the unsaved project): the four fields of
 * `investmentDeductionAllowance`.
 */
export const toProjectFinancingInput = (project) =>
  preparePayloadForGraphQL(
    project.investmentDeductionAllowance ?? {},
    PROJECT_FINANCING_FIELD_TYPES
  );
